// src/contexts/AuthContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = sessionStorage.getItem('paroquia_admin');
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch { sessionStorage.removeItem('paroquia_admin'); }
    }
    setLoading(false);
  }, []);

  const login = async (usuario, senha) => {
    const res = await apiLogin(usuario, senha);
    if (res.success) {
      const u = { usuario, nome: res.nome || usuario };
      setUser(u);
      sessionStorage.setItem('paroquia_admin', JSON.stringify(u));
      return true;
    }
    return false;
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('paroquia_admin');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
